import React from 'react';
import wcLogo from 'resources/HOR-White_WCCdotcom.png';

function AuthTop({ children, hideLogo = false }) {
  return (
    <div className="top">
      <div className="child">
        {!hideLogo && <img src={wcLogo} alt="logo" className="logo" />}
        {children}
      </div>
    </div>
  );
}

export default AuthTop;



// WEBPACK FOOTER //
// ./src/components/AuthTop/index.js